import Calendar from "./modules/year-planner/Calendar";

function App() {
	return (
		<div className={"container-fluid"}>
			<Calendar />
		</div>
	);
}

export default App;
